
import { EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringSearchCriteria";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import moment from "moment";
import { useBankInterfaceMonitoringMaintenanceVM } from "presentation/hook/BankInterfaceMonitoring/useBankInterfaceMonitoringMaintenanceVM";
import { useBankInterfaceMonitoringMaintenanceTracked } from "presentation/store/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import BankInterfaceMonitoringRightPanel from "./BankInterfaceMonitoringRightPanel";
import BankInterfaceMonitoringTitleBar from "./BankInterfaceMonitoringTitleBar";
import { BankInterfaceMonitoringMainSearchPanel } from "./LeftPanel/BankInterfaceMonitoringMainSearchPanel";

const BankInterfaceMonitoringMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [bankInterfaceMonitoringState] = useBankInterfaceMonitoringMaintenanceTracked();
    const { isShowSearchPanel } = bankInterfaceMonitoringState;
    const bankInterfaceMonitoringVM = useBankInterfaceMonitoringMaintenanceVM();


    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            bankInterfaceMonitoringVM.setIsSearchLoading(true);
            let newSearchCriteria = { ...EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA }
            newSearchCriteria = {
                ...newSearchCriteria,
                dateFrom: moment().subtract(getDefaultBuConfig("REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE"), "days").startOf("day").toDate(),
                dateTo: moment().endOf("day").toDate(),
                // dateFrom: moment().subtract(8, "years").startOf("day").toDate(),
                // dateTo: moment().endOf("day").toDate(),
            };

            await Promise.allSettled([
                bankInterfaceMonitoringVM.loadDropdownOption(),
                bankInterfaceMonitoringVM.onSearch(newSearchCriteria),
            ]);
        }
        initialScreen().then(() => {
            setIsLoading(false);
            bankInterfaceMonitoringVM.setIsSearchLoading(false);
        }).catch(error => {
            setIsLoading(false)
            bankInterfaceMonitoringVM.setIsSearchLoading(false);
        });

    }, [bankInterfaceMonitoringVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${isShowSearchPanel ? '' : ' im-hide-side-form-draggable'}`}>
            {<BankInterfaceMonitoringTitleBar />}

            {
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={isShowSearchPanel ? "30%" : "0%"}
                    rightSectionWidth={isShowSearchPanel ? "70%" : "100%"}
                    leftChildren={<BankInterfaceMonitoringMainSearchPanel />}
                    rightChildren={<BankInterfaceMonitoringRightPanel />}
                />
            }
        </div>
    </>
}

export default memo(BankInterfaceMonitoringMaintenance);